// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa5cb292","239":"021a7968","732":"572ed0d5","821":"2e613657"}[chunkId] + ".chunk.js";
};